import React, { useContext } from "react";
import "./Luxury_Hospitality.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { IDS } from "../../../../utils/IDS";
import { Context } from "../../../../utils/context";

function Luxury_Hospitality({ data }) {

  const { language } = useContext(Context);

  return (
    <section className="Luxury_Hospitality">
      <div className="container">
        <div className="heading_text_holder">
          {/* <h2>Luxury Hospitality & Culinary Arts</h2> */}

           <h2>{language == 1 ? "Luxury Hospitality & Culinary Arts" : "Hôtellerie de luxe et arts culinaires"}</h2>
        </div>

        <div className="slider_holder">
          <Swiper
            pagination={{ clickable: true }}
            modules={[Pagination]}
            className="Luxury_Hospitality_mySwiper common_swiper"
          >
            {data?.length > 0 ? (
              data?.map((d) => (
                <SwiperSlide>
                  <div className="img_holder">
                    <img
                      className="Hospitality_img"
                      src={IDS?.IMG_URL + d?.image}
                      alt="swiper img"
                    />
                  </div>
                </SwiperSlide>
              ))
            ) : (
              <div className="text-center">No Data Found</div>
            )}

            {/* <SwiperSlide>
              <div className="img_holder">
                <img
                  className="Hospitality_img"
                  src="/assets/images/internship/new-images/river.jpeg"
                  alt="swiper img"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="img_holder">
                <img
                  className="Hospitality_img"
                  src="/assets/images/internship/new-images/city.jpeg"
                  alt="swiper img"
                />
              </div>
            </SwiperSlide> */}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Luxury_Hospitality;
